<template>
  <div class="your-skills">

    <header-bar process="signup"></header-bar>

    <section class="instructions">
      <div class="grid-container">
        <div class="col-4">
          <h2>Choose between <span class="bold">three</span> and <span class="bold">ten</span> of your skills you'd like to share. </h2>
          <input placeholder="Search Skills..." class="search" type="text" v-model="queryText">
        </div>
      </div>
    </section>

    <section class="item-selection">
      <div class="grid-container">

        <div v-if="govAndIntDevSkills.length">
          <h3 @click="toggleGroup('showGov')" :class="{'active': showGov}">Governance and International Development</h3>
            <div class="toggle" v-if="showGov">
              <div class="row" v-for="row in govAndIntDevSkills">
                <picker-item v-for="item, key in row" itemclass="skills" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
                </picker-item>
            </div>
          </div>
        </div>

        <div v-if="commsSkills.length">
          <h3 @click="toggleGroup('showCom')" :class="{'active': showCom}">Communications</h3>
          <div class="toggle" v-if="showCom">
            <div class="row" v-for="row in commsSkills">
              <picker-item v-for="item, key in row" itemclass="skills" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
              </picker-item>
            </div>
          </div>
        </div>

        <div v-if="businessSkills.length">
          <h3 @click="toggleGroup('showBus')" :class="{'active': showBus}">Business</h3>
          <div class="toggle" v-if="showBus">
            <div class="row" v-for="row in businessSkills">
              <picker-item v-for="item, key in row" itemclass="skills" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
              </picker-item>
            </div>
          </div>
        </div>

        <div v-if="designSkills.length">
          <h3 @click="toggleGroup('showDes')" :class="{'active': showDes}">Design and Creativity</h3>
          <div class="toggle" v-if="showDes">
            <div class="row" v-for="row in designSkills">
              <picker-item v-for="item, key in row" itemclass="skills" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
              </picker-item>
            </div>
          </div>
        </div>

        <div v-if="leadershipSkills.length">
          <h3 @click="toggleGroup('showLea')" :class="{'active': showLea}">Leadership and Management</h3>
          <div class="toggle" v-if="showLea">
            <div class="row" v-for="row in leadershipSkills">
              <picker-item v-for="item, key in row" itemclass="skills" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
              </picker-item>
            </div>
          </div>
        </div>

        <div v-if="analyticSkills.length">
          <h3 @click="toggleGroup('showAna')" :class="{'active': showAna}">Analysis and Research</h3>
          <div class="toggle" v-if="showAna">
            <div class="row" v-for="row in analyticSkills">
              <picker-item v-for="item, key in row" itemclass="skills" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
              </picker-item>
            </div>
          </div>
        </div>

        <div v-if="techSkills.length">
          <h3 @click="toggleGroup('showTec')" :class="{'active': showTec}">Technical and Information Skills</h3>
          <div class="toggle" v-if="showTec">
            <div class="row" v-for="row in techSkills">
              <picker-item v-for="item, key in row" itemclass="skills" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
              </picker-item>
            </div>
          </div>
        </div>

        <!-- <div v-if="languageSkills.length">
          <h3>Languages</h3>
          <div class="row" v-for="row in languageSkills">
            <picker-item v-for="item, key in row" itemclass="skills" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
            </picker-item>
          </div>
        </div> -->

        <div v-if="legalSkills.length">
          <h3 @click="toggleGroup('showLeg')" :class="{'active': showLeg}">Legal</h3>
          <div class="toggle" v-if="showLeg">
            <div class="row" v-for="row in legalSkills">
              <picker-item v-for="item, key in row" itemclass="skills" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
              </picker-item>
            </div>
          </div>
        </div>

        <div v-if="stemSkills.length">
          <h3 @click="toggleGroup('showSte')" :class="{'active': showSte}">STEM (science, technology, engineering and mathematics)</h3>
          <div class="toggle" v-if="showSte">
            <div class="row" v-for="row in stemSkills">
              <picker-item v-for="item, key in row" itemclass="skills" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
              </picker-item>
            </div>
          </div>
        </div>

<!--         <div class="row" v-for="row in chunkArray">
          <picker-item v-for="item, key in row" itemclass="skills" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
          </picker-item>
        </div> -->

      </div>
    </section>

    <section class="sign-up-navigation">
      <div class="grid-container">
        <a href="#" v-on:click.stop.prevent="stepBack" class="link-back">Choose area(s) of Africa</a>
        <a href="#" v-on:click.stop.prevent="progress" class="btn btn-big bg-four active">Next</a>
        <div class="item-added-holder">

          <slider :data="selectedItemTags" :items="noOfItems"></slider>

        </div>

      </div>
    </section>


  </div>
</template>

<script>
import { db } from '@/firebase'

import HeaderBar from '@/components/HeaderBar'
import PickerItem from '@/components/register/PickerItem'
import Slider from '@/components/register/Slider'

export default {
  data () {
    return {
      selectedItems: [],
      selectedItemTags: [],
      queryText: '',
      results: [],
      showGov: true,
      showCom: false,
      showBus: false,
      showDes: false,
      showLea: false,
      showAna: false,
      showTec: false,
      showLeg: false,
      showSte: false
    }
  },
  components: {
    HeaderBar,
    PickerItem,
    Slider
  },
  methods: {
    stepBack () {
      this.$parent.currentStep--
    },
    progress () {
      let itemData = {}

      let user = this.$root.user.uid
      for (var i = 0; i < this.selectedItems.length; ++i) {
        itemData[this.selectedItems[i]] = true
        // let userData = {[user]: true}
        // db.ref('attributes/skills/' + this.selectedItems[i] + '/users').update(userData)
      }

      let parent = this
      db.ref('users-registration/' + user + '/personality/have-skills').set(itemData, function () {
        // On complete
        console.log('saved')
        parent.$parent.currentStep++
      })
    },
    removeTag (id, name) {
      this.selectedItems.splice(this.selectedItems.indexOf(id), 1)
      this.selectedItemTags.splice(this.selectedItemTags.indexOf(name), 1)
    },
    chunkMethod: function (items) {
      let chunks = []
      let arr = items
      let i
      let chunkSize = 6

      for (i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize))
      }
      return chunks
    },
    toggleGroup: function (dataId) {
      if (this[dataId] === true) {
        this[dataId] = false
      } else {
        this.showGov = false
        this.showCom = false
        this.showBus = false
        this.showDes = false
        this.showLea = false
        this.showAna = false
        this.showTec = false
        this.showLeg = false
        this.showSte = false
        this[dataId] = true
      }
    }
  },
  computed: {
    chunkArray: function () {
      let chunks = []
      let arr = this.results
      let i
      let chunkSize = 6

      for (i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize))
      }
      return chunks
    },
    govAndIntDevSkills: function () {
      let arr = this.results.filter(function (el) {
        return el.category === 'Governance and International Development'
      })
      return this.chunkMethod(arr)
    },
    commsSkills: function () {
      let arr = this.results.filter(function (el) {
        return el.category === 'Communications'
      })
      return this.chunkMethod(arr)
    },
    businessSkills: function () {
      let arr = this.results.filter(function (el) {
        return el.category === 'Business'
      })
      return this.chunkMethod(arr)
    },
    designSkills: function () {
      let arr = this.results.filter(function (el) {
        return el.category === 'Design and Creativity'
      })
      return this.chunkMethod(arr)
    },
    leadershipSkills: function () {
      let arr = this.results.filter(function (el) {
        return el.category === 'Leadership and Management'
      })
      return this.chunkMethod(arr)
    },
    analyticSkills: function () {
      let arr = this.results.filter(function (el) {
        return el.category === 'Analysis and Research'
      })
      return this.chunkMethod(arr)
    },
    techSkills: function () {
      let arr = this.results.filter(function (el) {
        return el.category === 'Technical and Information Skills'
      })
      return this.chunkMethod(arr)
    },
    languageSkills: function () {
      let arr = this.results.filter(function (el) {
        return el.category === 'Languages'
      })
      return this.chunkMethod(arr)
    },
    legalSkills: function () {
      let arr = this.results.filter(function (el) {
        return el.category === 'Legal'
      })
      return this.chunkMethod(arr)
    },
    stemSkills: function () {
      let arr = this.results.filter(function (el) {
        return el.category === 'STEM'
      })
      return this.chunkMethod(arr)
    }
  },
  watch: {
    queryText: function (val) {
      let term = val.toLowerCase()
      if (term !== '') {
        this.showGov = true
        this.showCom = true
        this.showBus = true
        this.showDes = true
        this.showLea = true
        this.showAna = true
        this.showTec = true
        this.showLeg = true
        this.showSte = true
      } else {
        this.showGov = false
        this.showCom = false
        this.showBus = false
        this.showDes = false
        this.showLea = false
        this.showAna = false
        this.showTec = false
        this.showLeg = false
        this.showSte = false
      }
      this.$bindAsArray('results', db.ref('attributes/skills/').orderByChild('searchterm').startAt(term).endAt(term + '\uf8ff'))
    }
  },
  mounted () {
    this.$bindAsArray('results', db.ref('attributes/skills/').orderByChild('searchterm'))
  }
}
</script>



// WEBPACK FOOTER //
// Register-Step-7.vue?3f51b9c4